app.factory(
    'UserService', ['LocalStorage', 'ApiService', '$rootScope', UserService]
);

function UserService(LocalStorage, ApiService, $rootScope) {

    var self = {
        setUser: function (user) {
            LocalStorage.setObject('user', user);
        },

        getUser: function () {
            return LocalStorage.getObject('user');
        },
        unsetUser: function () {
            LocalStorage.unsetObject('user');
        },
        isLogged: function () {
            return LocalStorage.objectExists('user') && !LocalStorage.isEmpty('user');
        },
        getToken: function () {
            return self.isLogged() ? self.getUser().token : null;
        }
    };

    self.GetAll = GetAll;
    self.GetById = GetById;
    self.GetByUsername = GetByUsername;
    self.Create = Create;
    self.Update = Update;
    self.Delete = Delete;

    self.GetZone = GetZone;

    self.GetZoneMenuItemList = GetZoneMenuItemList;
    self.GetLogIn = GetLogIn;
    //self.GetAllLanguages= GetAllLanguages;

    //Users
    function GetAll() {
        return ApiService.get('/api/userAPI/GetAllUsers').then(handleSuccess, handleError('Error getting all users'));
    }

    function GetById(id) {
        return ApiService.get('/api/user/' + id).then(handleSuccess, handleError('Error getting user by id'));
    }

    function GetByUsername(username) {
        return ApiService.get('/API/userAPI/getuser/1').then(handleSuccess, handleError('Error getting user by username'));
    }

    function GetLogIn(user) {
        return ApiService.get('/API/accountAPI/GetLogIn').then(handleSuccess, handleError('Error getting user by username'));
    }

    function Create(user) {
        return ApiService.post('/api/user', user).then(handleSuccess, handleError('Error creating user'));
    }

    function Update(user) {
        return ApiService.put('/api/user/' + user.id, user).then(handleSuccess, handleError('Error updating user'));
    }

    function Delete(id) {
        return ApiService.delete('/api/userAPI/DeleteUser/' + id).then(handleSuccess, handleError('Error deleting user'));
    }
    

    //Zone    
    function GetZone(id, lang) {
        return ApiService.get('/api/zoneApi/GetZone?id=' + id + '&lang=' + lang).then(handleSuccess, handleError('Error getting Zone'));;
    }

    function GetZoneMenuItemList() {
        return ApiService.get('/api/zoneApi/GetZoneMenuItemList').then(handleSuccess, handleError('Error getting all zones'));
    }

    //Languages
    self.GetAllLanguages = function () {
        return ApiService.get('/api/userApi/GetAllLanguages').then(handleSuccess, handleError('Error getting all languages'));
    }

    //RolesZones    

    self.AddUserRoleZone = function (userName, roleId, zoneId) {
        var d = {};
        d.UserName = userName;
        d.RoleId = roleId;
        d.ZoneId = zoneId;
        return ApiService.post('/api/userAPI/AssociateRoleZoneToUser', d).then(handleSuccess, handleError('Error updating AddUserRoleZone'));

        //return ApiService.get('/api/userAPI/GetAllUsersJson').then(handleSuccess, handleError('Error getting all users'));
    }

    //Get User List
    self.GetUserList = function (itemsPerPage, pagenumber, sortKey, reverse, lang) {
        return ApiService.get("/api/userAPI/GetUserList?itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang);
    }

    //Get Zone List
    self.GetZoneList = function (itemsPerPage, pagenumber, sortKey, reverse, lang) {
        return ApiService.get("/api/userAPI/GetZoneList?itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang);
    }

    // private functions

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }


    return self;
}